import { gsap } from "gsap";
import Cookies from "js-cookie";
import { focusHelper, removeFocusHelper } from "../helpers/focus-helper.js";

class Dialog extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.popupContent = this.querySelector(".popup-content");
        this.popupDocument = this.querySelector("[role='dialog']");
        this.overlay = this.querySelector(".dialog-overlay");
        this.closeButton = this.querySelector("button[data-dialog-hide]");
        const type = this.getAttribute("data-type");

        this.onCloseClickHandler = this.onCloseClick.bind(this);
        this.escapeHandler = this.onPressEscape.bind(this);
        this.closeHandler = this.close.bind(this);
        this.openHandler = this.open.bind(this);

        if (type === "newsletter") {
            this.openButton = document.querySelector("button[data-dialog-show='newsletter']");
            this.openButton.addEventListener("click", this.openHandler);
            this.submitTemplate = document.getElementById("submit-template");
            this.submitfromTemplate = this.submitTemplate.content.cloneNode(true);

            window.addEventListener("DOMContentLoaded", () => {
                const dialogPopup = document.querySelector("dialog-newsletter");
                if (dialogPopup) {
                    setTimeout(function () {
                        dialogPopup.setupDialogNewsletter();
                    }, 1000);
                }
            });
        }

        if (type === "popup") {
            this.delayAttribute = this.getAttribute("data-delay") ? +this.getAttribute("data-delay") : 10;
            this.cookieId = this.id;
            const delay = this.delayAttribute * 1000;
            const dialogPopup = document.querySelector("dialog-popup");
            this.linkButton = this.querySelector(".button.primary-button");
            if (this.linkButton) this.linkButton.addEventListener("click", this.closeHandler);

            window.addEventListener("DOMContentLoaded", () => {
                if (!Cookies.get(this.cookieId)) {
                    setTimeout(function () {
                        dialogPopup.open();
                    }, delay);
                }
                // else {
                //     console.log("cookie exists");
                // }
            });
        }

        this.closeEvents();
    }

    closeEvents() {
        document.addEventListener("keyup", this.escapeHandler);
        this.closeButton.addEventListener("click", this.onCloseClickHandler);
        this.overlay.addEventListener("click", this.onCloseClickHandler);
    }

    close() {
        if (this.getAttribute("aria-hidden")) return;
        const type = this.getAttribute("data-type");
        this.hide();
        this.setAttribute("aria-hidden", "true");
        if (type === "popup") {
            Cookies.set(this.cookieId, true, { expires: 3 });
        }
    }

    open() {
        if (!this.getAttribute("aria-hidden")) return;
        this.removeAttribute("aria-hidden");
        this.show();
    }

    show() {
        const onCompleteHandler = () => {
            focusHelper(this);
            document.documentElement.classList.add("no-scroll");
        };
        const timeline = gsap.timeline({ paused: true });
        timeline
            .to(this, { autoAlpha: 1, duration: 0.1 })
            .to(this.overlay, { alpha: 1, duration: 0.5, ease: "power2.out" }, ">")
            .to(
                this.popupDocument,
                { scale: 1, alpha: 1, duration: 0.5, ease: "power2.out", onComplete: onCompleteHandler },
                ">"
            );

        timeline.play();
    }

    hide() {
        const onCompleteHandler = () => {
            if (this.getAttribute("data-type") === "newsletter") {
                removeFocusHelper(this.openButton);
            } else {
                removeFocusHelper();
            }
            document.documentElement.classList.remove("no-scroll");
        };
        const timeline = gsap.timeline({ paused: true });
        timeline
            .to(this.popupDocument, { scale: 0.95, alpha: 0, duration: 0.3, ease: "power2.out" })
            .to(this.overlay, { alpha: 0, duration: 0.3, ease: "power2.out" }, ">")
            .to(this, { autoAlpha: 0, duration: 0.1, onComplete: onCompleteHandler }, ">");
        timeline.play();
    }

    onPressEscape(event) {
        if (this.getAttribute("aria-hidden")) return;

        if (event.code.toUpperCase() === "ESCAPE") {
            this.close();
        }
    }

    onCloseClick(event) {
        if (this.getAttribute("aria-hidden")) return;
        if (this.overlay === event.target || this.closeButton === event.target) {
            this.close();
        }
    }

    setupDialogNewsletter() {
        this.submitContainer = this.popupContent.querySelector("form .hs-submit.hs-submit .actions")
            ? this.popupContent.querySelector("form .hs-submit.hs-submit .actions")
            : false;

        if (this.submitContainer) {
            this.submitContainer.replaceChildren(this.submitfromTemplate);
        }
    }
}

class DialogNewsletter extends Dialog {
    constructor() {
        super();
    }
}

customElements.define("dialog-newsletter", DialogNewsletter);

class DialogPopup extends Dialog {
    constructor() {
        super();
    }
}

customElements.define("dialog-popup", DialogPopup);
